import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../consts";
import { t } from "../../../services";

import {
  Checkbox,
  FlexContainers,
  Modal,
  SmallButton,
  WrapperContainer
} from "../../../components";
import { CheckboxLabel } from "../../../components/Checkbox/styled";

const ExportInsightsModal = ({ active, setActive, onExport }) => {
  const [includeFilters, setIncludeFilters] = useState(true);

  useEffect(() => {
    if (active) {
      setIncludeFilters(true);
    }
  }, [active]);

  return (
    <Modal
      id="export-insights-modal"
      active={active}
      setActive={setActive}
      closable={false}
      title={t(strCode.EXPORT_TABLE_TITLE)}>
      <WrapperContainer Container={FlexContainers.FlexColumn} width={315}>
        <WrapperContainer Container={FlexContainers.FlexRowStart} gap={16} width={"100%"}>
          <Checkbox
            id={"include-filters"}
            checked={includeFilters}
            onCheck={() => setIncludeFilters((prev) => !prev)}
          />
          <CheckboxLabel for={"include-filters"}>{t(strCode.INCLUDE_FILTERS_LABEL)}</CheckboxLabel>
        </WrapperContainer>

        <WrapperContainer Container={FlexContainers.FlexRowEnd} mt={24} width="100%" gap={8}>
          <SmallButton secondary onClick={() => setActive(false)}>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>
          <SmallButton
            onClick={() => {
              setActive(false);
              onExport(includeFilters);
            }}>
            {t(strCode.EXPORT_BTN)}
          </SmallButton>
        </WrapperContainer>
      </WrapperContainer>
    </Modal>
  );
};

ExportInsightsModal.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired
};

export default ExportInsightsModal;
